var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{ref:"label",staticClass:"label",style:(_vm.labelStyle)},[(_vm.required)?_c('span',{staticClass:"required"},[_vm._v("*")]):_vm._e(),_vm._v(" "+_vm._s(_vm.label)+" "),(_vm.colon)?_c('span',[_vm._v("：")]):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }